export const parseQuantityBreaks = (value: string) => {
  const tokens = value.split(/[\s,;]+/).filter(Boolean)
  const quantities = tokens.map(Number)
  const invalid = quantities.some(
    (quantity) => !Number.isFinite(quantity) || quantity <= 0,
  )
  return {
    quantities: invalid ? [] : [...new Set(quantities)].sort((a, b) => a - b),
    error: invalid
      ? 'Enter positive quantities separated by commas, for example 10, 50, 100.'
      : '',
  }
}
